/**
 * Initializes a ck editor, expects windows.ClassicEditor to exist
 *
 * @param {Element} element
 * @param {Object} config
 */
function initCKEditor(element, config = {}) {
	const defaultConfig = {
		toolbar: {
			items: [
				"heading",
				'|',
				"bold",
				"italic",
				'|',
				"alignment",
				"fontBackgroundColor",
				"fontColor",
				"fontFamily",
				"fontSize",
				'|',
				"indent",
				"outdent",
				'|',
				"htmlEmbed",
				"imageInsert",
				"mediaEmbed",
				"insertTable",
				"numberedList",
				"bulletedList",
				"horizontalLine",
				'|',
				"link",
				"linkImage",
				'|',
				"undo",
				"redo",
			],
			shouldNotGroupWhenFull: true
		}
	}

	const finalConfig = {
		...defaultConfig,
		...config,
	}

	return window.ClassicEditor
		.create(element, finalConfig);
}

/**
 * Inserts a string at the caret position/selection in the given editor
 *
 * @param editor
 * @param text
 */
function insertAtSelection(editor, text) {
	editor.model.change(writer => {
		// Remove selection if required
		const selectedRange = editor.model.document.selection.getFirstRange();
		if (selectedRange) {
			// First lets check if we are inside a HTML raw embed
			const selectionNode = document.getSelection().anchorNode;
			if (
				// Something is selected
				selectionNode &&
				// And is an element
				selectionNode.nodeType === 1 &&
				// And is ckeditor raw html editor
				selectionNode.classList.contains('raw-html-embed__source')
			) {
				// Get selection positions
				const start = selectionNode.selectionStart;
				const end = selectionNode.selectionEnd;

				const beforeSelection = selectionNode.value.slice(0, start);
				const afterSelection = selectionNode.value.slice(end);

				// Replace textarea value with new text inserted
				selectionNode.value = `${beforeSelection}${text}${afterSelection}`;
			} else {
				// Insert text
				writer.insertText(
					text,
					editor.model.document.selection.getFirstPosition()
				);

				// Remove selection
				writer.remove(editor.model.document.selection.getFirstRange());
			}
		} else {
			// Simply insert text
			writer.insertText(
				text,
				editor.model.document.selection.getFirstPosition()
			);
		}
	});
}

export {
	initCKEditor,
	insertAtSelection
}
